import React from 'react'
import firebase from 'firebase'

const logoutOnClick = () => firebase.logout()

const Logout = () => (
  <button onClick={logoutOnClick}>
    Logout
  </button>
)

export default Logout



// WEBPACK FOOTER //
// ./src/components/AppAuth/Logout.js